import Header from "./components/UI/Header/Header.jsx";
import Home from "./components/Home/Home.jsx";

function App() {
  return (
    <>
      <Header />
      <Home />
    </>
  );
}

export default App;
